import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveWithdrawalAccountsMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { SaveWithdrawalAccountsParam } from 'api/types/params';
import { parseCurrencyParam } from 'helpers/parseCurrencyParam';

import { parseLegalClient } from './helpers';

export const useLegalClientSaveWithdrawalAccounts = () => {
  const [saveWithdrawalAccounts, { data, loading, error: apolloError }] =
    useLegalClientSaveWithdrawalAccountsMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveWithdrawalAccounts
      ? parseLegalClient(data.legalClientSaveWithdrawalAccounts)
      : undefined,
    loading,
    error,
    saveWithdrawalAccounts: useCallback(
      async (id: string, params: SaveWithdrawalAccountsParam) => {
        const res = await saveWithdrawalAccounts({
          variables: {
            id,
            input: {
              withdrawalAccounts: params.withdrawalAccounts.map((p) => ({
                ...p,
                currency: parseCurrencyParam(p.currency),
              })),
            },
          },
        });
        return res.data?.legalClientSaveWithdrawalAccounts
          ? parseLegalClient(res.data.legalClientSaveWithdrawalAccounts)
          : undefined;
      },
      [saveWithdrawalAccounts]
    ),
  };
};
